<table>
    <thead>
        <tr>
            <th class="subtable">{{'asociar-traducciones.idioma' | translate}}</th>
            <th class="subtable">{{'asociar-traducciones.traduccion' | translate}}</th>
            <th class="subtable action">
                <i class="fas fa-plus" (click)="new=true" title="{{'titles.crearTraduccion' | translate}}"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <app-traducciones class="component-in-row" *ngIf="new" [objetoId]="this.objeto.id" [nombreComponente]="this.nombreComponente" (refresh)="toRefresh($event)" (close)="new=$event"></app-traducciones>
        <app-traducciones class="component-in-row" *ngFor="let traduccion of this.traducciones" [objetoId]="this.objeto.id" [traduccion]="traduccion" [nombreComponente]="this.nombreComponente" (refresh)="toRefresh($event)"></app-traducciones>
    </tbody>
    <tfoot *ngIf="this.objeto.Idiomas && this.objeto.Idiomas.length < 1 && !new">
        <tr>
          <td colspan="10">
            {{'global.noContent' | translate}}
          </td>
        </tr>
      </tfoot>
</table>
